import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=448d5b97&scoped=true&lang=pug&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&id=448d5b97&lang=sass&nolang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d5b97",
  null
  
)

export default component.exports